import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  ManualWalletAdjustmentRequest,
  ManualWalletAdjustmentResponse,
  walletsService,
} from '@aslanpay/portal-common-lib';

interface CreateManualAdjustmentParams {
  walletId: string;
  request: ManualWalletAdjustmentRequest;
}

const useCreateManualAdjustment = () => {
  const queryClient = useQueryClient();

  return useMutation<ManualWalletAdjustmentResponse, Error, CreateManualAdjustmentParams>({
    mutationFn: ({ walletId, request }) => walletsService.createManualAdjustment(walletId, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fetchWallets'] });
      queryClient.invalidateQueries({ queryKey: ['fetchTransactionsPage'] });
    },
  });
};

export default useCreateManualAdjustment;
